/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import axios from 'axios';
import { ENVIRONMENT } from 'config';
import TIME_OUTS from '../constants/time-outs';
import { getClientId } from './client-id';
/**
 * Plain axios instance for the refresh-token call. It deliberately has no auth
 * interceptor, so refreshing can never re-enter refreshTokens().
 */
const refreshClient = axios.create({
  baseURL: ENVIRONMENT.BACKEND_API,
  timeout: TIME_OUTS.REQUEST_TIMEOUT_MS,
  timeoutErrorMessage: 'Request timed out',
});
refreshClient.interceptors.request.use((requestConfig) => {
  const config = requestConfig;
  config.headers['X-Client-ID'] = getClientId();
  return config;
});
//
export default refreshClient;
